import React, { useState } from 'react';
import SubscriptionsTable from '../components/SubscriptionsTable';
import useSubscriptions from '../hooks/useSubscriptions';
import SubscriptionFormModal from '../components/SubscriptionFormModal';
import SubscriptionPaymentsModal from '../components/SubscriptionPaymentsModal';
import FlashMessage from '../components/FlashMessage';
import {
  PageContainer,
  ContentContainer,
  Header,
  AddButton,
  Label,
} from '../styles/ComponentStyles';
import apiService from '../services/apiService';

const Subscriptions = ({ isSidebarOpen }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageLimit, setCurrentPageLimit] = useState(100);
  const { subscriptions, totalItems, totalPages, loading, error } = useSubscriptions(
    currentPage,
    currentPageLimit,
    refreshKey
  );
  const [flashMessage, setFlashMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [paymentsForSubscription, setPaymentsForSubscription] = useState(null);

  const refreshData = () => setRefreshKey((k) => k + 1);

  const handleFlashMessage = (msg) => {
    setFlashMessage(msg);
    setTimeout(() => setFlashMessage(''), 3000);
  };

  const handlePageChange = (p) => setCurrentPage(p);
  const handlePageLimitChange = (l) => setCurrentPageLimit(l);

  const handleAdd = () => {
    setEditingItem(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingItem(null);
  };

  const handleViewPayments = (sub) => setPaymentsForSubscription(sub);
  const handleClosePaymentsModal = () => setPaymentsForSubscription(null);

  const handleSubmit = async (payload) => {
    try {
      if (editingItem) {
        await apiService.putSubscription(editingItem._id, payload);
        handleFlashMessage('Subscription updated.');
      } else {
        await apiService.postSubscription(payload);
        handleFlashMessage('Subscription added.');
      }
      refreshData();
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || 'Something went wrong';
      handleFlashMessage(`Error: ${msg}`);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await apiService.deleteSubscription(id);
      handleFlashMessage(res?.data?.message || res?.message || 'Deleted.');
      refreshData();
    } catch (err) {
      handleFlashMessage(err?.response?.data?.detail || 'Error deleting.');
    }
  };

  return (
    <PageContainer>
      <ContentContainer isSidebarOpen={isSidebarOpen}>
        <Header>
          <h1>Subscriptions & Installments</h1>
          <AddButton onClick={handleAdd}>Add New</AddButton>
        </Header>
        <div>
          <Label>Total: {totalItems}</Label>
          <Label>Pages: {totalPages}</Label>
        </div>
        {flashMessage && <FlashMessage message={flashMessage} />}
        <SubscriptionsTable
          subscriptions={subscriptions}
          loading={loading}
          error={error}
          handleFlashMessage={handleFlashMessage}
          handleDelete={handleDelete}
          currentPage={currentPage}
          currentPageLimit={currentPageLimit}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onPageLimitChange={handlePageLimitChange}
          onEdit={handleEdit}
          onViewPayments={handleViewPayments}
        />
      </ContentContainer>

      {showModal && (
        <SubscriptionFormModal
          editing={!!editingItem}
          initialData={editingItem}
          onSubmit={handleSubmit}
          onClose={handleCloseModal}
        />
      )}

      {paymentsForSubscription && (
        <SubscriptionPaymentsModal
          subscription={paymentsForSubscription}
          onClose={handleClosePaymentsModal}
          onRefresh={refreshData}
        />
      )}
    </PageContainer>
  );
};

export default Subscriptions;
